import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { BaseAccount } from '@shared/models';

@Component({
  selector: 'app-account-signature',
  templateUrl: './account-signature.component.html',
  styleUrls: ['./account-signature.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountSignatureComponent {
  @Input({ required: true }) account: BaseAccount;
  @Input() useOnlyAvatar = true;
  @Input() shouldDisplayTooltip = false;
  @Input() shouldDisplayEmail = false;
  @Input() avatarSize: 'medium' | 'large' | 'jumbo' = 'medium';

  get emailParts(): { localPart: string; domainPart: string } {
    const lastAtIndex = this.account.email.lastIndexOf('@');

    return {
      localPart: this.account.email.slice(0, lastAtIndex + 1),
      domainPart: this.account.email.slice(lastAtIndex + 1),
    };
  }
}
